export const isFunctionalKey = keyCode => {
  if (keyCode === 38 || keyCode === 40 || keyCode === 27 || keyCode === 13) {
    return true
  }

  return false
}
